import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import ReactGA from 'react-ga';
import EmojiAttribution from './emoji_attribution/emoji_attribution';
import AppDisplayName from './app_display_name/app_display_name';

import GA from '../../services/ga_events';

import './app_footer.scss';

export default function AppFooter(props) {
  const showAttribution = props.currentPath === '/';

  return (
    <div className="app-footer">
      <div className="app-footer-links">
        <Link
          to="/faq"
          onClick={() => {
            ReactGA.event(GA.FAQ);
          }
        }
        >
          FAQ
        </Link>
        <Link
          to="/privacy_policy"
          onClick={() => {
            ReactGA.event(GA.privacyPolicy);
          }
        }
        >
          Privacy Policy
        </Link>
        <HashLink
          to="/faq#contact-us-section"
          onClick={() => {
            ReactGA.event(GA.contactUs);
          }
        }
        >
          Contact
        </HashLink>
      </div>

      <div className="app-footer-extras">
        {
          showAttribution &&
            <EmojiAttribution />
        }

        <AppDisplayName />
      </div>
    </div>
  );
}

AppFooter.propTypes = {
  currentPath: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/app_footer/app_footer.jsx